import { render, staticRenderFns } from "./ProductsFeatures.vue?vue&type=template&id=1ecabcd7"
import script from "./ProductsFeatures.vue?vue&type=script&lang=js"
export * from "./ProductsFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports